import styled from '@emotion/styled';
import Star from '@mui/icons-material/Star';
import React from 'react';

import {
  LeftNavMenu,
  LeftNavMenuItem,
} from '~/client/components/base/left-nav';

interface Props {
  className?: string;
}

const OrganizationImpl: React.FC<Props> = ({ className }) => {
  const [selected, setSelected] = React.useState<string>();

  return (
    <LeftNavMenu
      className={className}
      name="organization"
      header={{ renderText: () => 'Back' }}
    >
      {Array.from({ length: 20 }, (_, idx) => {
        const itemName = `item${idx + 1}`;
        return (
          <LeftNavMenuItem
            key={idx}
            icon={Star}
            selected={selected === itemName}
            onClick={() => setSelected(itemName)}
          >
            {itemName}
          </LeftNavMenuItem>
        );
      })}
    </LeftNavMenu>
  );
};

const Organization = styled(OrganizationImpl)``;

export default Organization;
